import { lazy, Suspense } from "react";
import { Loader } from "@/components";
import TableFiltersContextProvider from "@/common/contexts/Table.context";

const Notification = lazy(() => import("@/pages/Notification.page"));

const notificationRoute = [
  {
    path: "notification",
    element: (
      <Suspense fallback={<Loader />}>
        <TableFiltersContextProvider>
          <Notification />
        </TableFiltersContextProvider>
      </Suspense>
    ),
  },
];
export default notificationRoute;
